export function createHistory(max = 80) {
  const past = [];
  const future = [];
  let present = null;

  function clone(snapshot) {
    return JSON.parse(JSON.stringify(snapshot));
  }

  return {
    reset(snapshot) {
      present = clone(snapshot);
      past.length = 0;
      future.length = 0;
    },
    commit(snapshot) {
      if (!present) {
        present = clone(snapshot);
        return;
      }
      past.push(clone(present));
      if (past.length > max) past.shift();
      present = clone(snapshot);
      future.length = 0;
    },
    undo() {
      if (!past.length) return null;
      future.push(clone(present));
      present = past.pop();
      return clone(present);
    },
    redo() {
      if (!future.length) return null;
      past.push(clone(present));
      present = future.pop();
      return clone(present);
    },
    canUndo() {
      return past.length > 0;
    },
    canRedo() {
      return future.length > 0;
    },
  };
}
